import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalProps } from "Components/ReactstrapSlim";
import { HourlyRequestsClient, ReservationRequestDetailsModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { LayoutContext } from "Components/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import LsLoading, { useLsLoading } from "Components/LsLoading";
import { CommonDetails } from "./CommonDetails";
import { getOwnerStatus } from "./helpers";
import classes from "./HourlyRequest.module.scss";

interface HourlyRequestToBookDetailsModalProps extends ModalProps {
   requestId: Guid,
   toggle: () => void,
}

const HourlyRequestToBookDetailsModal: React.FC<HourlyRequestToBookDetailsModalProps> = ({ requestId, toggle, ...modalProps }) => {
   const layoutContext = useContext(LayoutContext);
   const [model, setModel] = useState<ReservationRequestDetailsModel | undefined>(undefined);
   const [loadingWrapper, isLoading, setIsLoading] = useLsLoading(true);

   const hourlyRequestToBookClient = useApiClient(HourlyRequestsClient);

   const load = async (abortSignal?: AbortSignal) => {
      setIsLoading(true)
      try {
         setModel(await hourlyRequestToBookClient.hourlyRequestReservationDetails(requestId, abortSignal));
      }
      catch (ex) {
         if (!abortSignal?.aborted)
            layoutContext.showError(ex);
      }
      finally {
         setIsLoading(false);
      }
   }

   useEffect(() => {
      const abort = new AbortController();
      load(abort.signal);
      return function cancel() {
         abort.abort();
      }
   }, [requestId]);


   return (<Modal {...modalProps} toggle={toggle}>
      <ModalHeader toggle={toggle}>Reservation Request</ModalHeader>
      <ModalBody className={loadingWrapper} style={{ minHeight: "200px" }}>
         <LsLoading isLoading={isLoading} />
         {!!model && <>
            <div className={classes.status}>
               {getOwnerStatus(model)}
            </div>
            <CommonDetails request={model} />
         </>}
      </ModalBody>
      <ModalFooter>
         <Button type="button" color="primary" onClick={toggle}>Ok</Button>
      </ModalFooter>
   </Modal>)
}

export default HourlyRequestToBookDetailsModal